import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionWheelchairAccessible"
const OptionWheelchairAccessibleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M9 5.4c.8.8 2 .8 2.8 0s.8-2 0-2.8c-.4-.4-.9-.6-1.4-.6s-1 .2-1.4.6c-.8.8-.8 2 0 2.8zM14.1 16.4h-2c-.1 1.8-1.6 3.3-3.5 3.3s-3.5-1.6-3.5-3.5c0-1.5 1-2.8 2.3-3.3v-2.1c-2.5.5-4.4 2.8-4.4 5.4 0 3.1 2.5 5.5 5.5 5.5s5.5-2.3 5.6-5.3z" />
          <path d="M10.9 6.9h-.5c-1.1 0-2 .9-2 2v3.6c0 1.7 1.3 3 3 3h5.1L20 19l1.4-1.4-5.1-5.1h-3.4V8.9c0-1.1-.9-2-2-2z" />
          <path d="M16 10.8h-4.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9H16c.5 0 .9.4.9.9s-.4.9-.9.9z" />
        </svg>
      }
    </span>
  )
}
export default OptionWheelchairAccessibleIcon
